module.exports = __webpack_public_path__ + "slickFilters.a915173a2fd2a85fd30c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slickFilters.svg
// module id = ./src/assets/img/slickFilters.svg
// module chunks = main